import React from "react";
import cx from "classnames";
import { Trans } from "@elevio/kb-kit/lib/components/trans";
import LoginLogout from "./LoginLogout";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
const CONTACT_US = 'https://rivco.org/search/global?keys=contact+us';
const FACEBOOK_URL = 'https://www.facebook.com/RivCoNow/';
const X_URL = 'https://x.com/rivconow';
const INSTAGRAM_URL = 'https://www.instagram.com/rivconow';
function Footer({ className }) {
    return (<footer className={cx("footer", className)} data-testid="footer">
      <div className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav">
          <a className="footer-link" target="_blank" href={CONTACT_US}>
            <Trans>Contact Us</Trans>
          </a>
          <a className="footer-link" target="_blank" href={FACEBOOK_URL}>
            <FontAwesomeIcon icon={faFacebookF}/>
          </a>
          <a className="footer-link" target="_blank" href={X_URL}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16" fill="currentColor">
              <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
            </svg>
          </a>
          <a className="footer-link" target="_blank" href={INSTAGRAM_URL}>
            <FontAwesomeIcon icon={faInstagram}/>
          </a>
          <LoginLogout className="footer-link"/>
        </nav>
      </div>
    </footer>);
}
export default Footer;
